import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { FormSubmitHandler } from 'Elements/Form';

import FilterUsers from './FilterUsers';
import { Schema as UserParamsSchema } from './schema';
import UsersTable from './UsersTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function UserList() {
  const [params, setParams] = useState();

  const onSubmit: FormSubmitHandler<UserParamsSchema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterUsers onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <UsersTable params={params} />
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  return params;
};
